var plugin_files = {
    flow: [{
        name: "iq_flow_common",
        files: ['modules/flow/flow_directive.js']
    }],
    task: [{
        name: "iq_common",
        files: ['modules/task/public_task.js']
    }],
    schedul: [{
        name: 'iq_common',
        files: ['modules/schedul/public_schedul.js']
    }],
    rule: [{
        name: "iq_common",
        files: ['modules/rule/public_rule.js']

    }],
    note: [{
        name: "iq_common",
        files: ['modules/note/public_note.js']

    }],
    netdisk: [{
    	name: "iq_netdisk_common",
    	files: ['modules/netdisk/public_netdisk.js']
    }],
    chart: [{
        files: ['../lib/plugins/chart/chart.js']

    }],
    uiMask: [{
        name: "ui.mask",
        files: ['../lib/plugins/ui-mask/mask.js']
    }],
    uiSelect: [{
        name: "ui.select",
        files: ['../lib/plugins/ui-select/select.min.js', '../lib/plugins/ui-select/select.css']
    }],
    uiSortable: [{
        name: 'ui.sortable',
        files: ['../lib/plugins/ui-sortable/sortable.js']
    }],
    uiTinymce: [{
        name: 'ui.tinymce',
        files: ['../lib/plugins/ui-tinymce-master/tinymce.min.js', '../lib/plugins/jquery-file-upload/jquery.fileupload.js', '../lib/plugins/jquery-file-upload/jquery.iframe-transport.js', '../lib/plugins/ui-tinymce-master/ui-tinymce.js']
    }],
    ngGrid: [{
        name: 'ngGrid',
        files: ['../lib/plugins/nggrid/ng-grid-2.0.3.min.js']
    }, {
        insertBefore: '#loadBefore',
        files: ['../lib/plugins/nggrid/ng-grid.css']
    }],
    jqueryFileupload: [{
        files: ['../lib/plugins/jquery-file-upload/jquery.fileupload.js', '../lib/plugins/jquery-file-upload/jquery.iframe-transport.js']
    }],
    chosen: [{
        insertBefore: '#loadBefore',
        name: 'localytics.directives',
        files: ['../lib/plugins/chosen/chosen.css',
            '../lib/plugins/chosen/chosen.jquery.js',
            '../lib/plugins/chosen/chosen.js'
        ]

    }],
    "angularFileUpload": [{
        name: 'angularFileUpload',
        files: [
            '../lib/plugins/angular-upload/angular-file-upload.js'
        ]
    }],
    "jqueryMedia": [{
        files: ['../lib/plugins/jquery-media/jquery.media.js']
    }],
    ngImgCrop: [{
        name: 'ngImgCrop',
        insertBefore: '#loadBefore',
        files: ['../lib/plugins/ngImgCrop/ng-img-crop.js',
            '../lib/plugins/ngImgCrop/ng-img-crop.css'
        ]
    }],
    datetimepicker: [{
        files: ['/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.js',
            '/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.css'
        ]
    }],
    ngJcrop: [{
        name: 'ngJcrop',
        files: ['../lib/plugins/ngjcrop/jquery.Jcrop.min.js',
            '../lib/plugins/ngjcrop/ng-jcrop.js',
            '../lib/plugins/ngjcrop/jquery.Jcrop.min.css'
        ]
    }],
    fileUpload: [{
        name: "dc_file_upload",
        files: ["../lib/plugins/ng-file-upload/ng-file-upload.js", "modules/fileupload/js/app.min.js"]
    }]
}
if(old_browser.IE && old_browser.version == "9"){
	plugin_files["angularFileUpload"][0].files.push("../lib/plugins/angular-upload/ng-file-upload-shim.min.js'")
}
var getPlugin_files = function(list) {
    var res = [];
    for (var i = 0; i < list.length; i++) {
        res = res.concat(plugin_files[list[i]])
    }
    return res;
}
